import React, { useState, useRef } from 'react';

const Accordion = ({ items, className = '' }) => {
  const [openItems, setOpenItems] = useState(new Set());
  const accordionRef = useRef(null);

  const toggleItem = (index) => {
    setOpenItems(prev => {
      const newSet = new Set(prev);
      if (newSet.has(index)) {
        newSet.delete(index);
      } else {
        newSet.add(index);
      }
      return newSet;
    });
  };

  const handleKeyDown = (event, index) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      toggleItem(index);
    }
  };

  const handleArrowKey = (event, currentIndex) => {
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      const nextIndex = Math.min(currentIndex + 1, items.length - 1);
      const nextButton = accordionRef.current?.querySelector(`[data-index="${nextIndex}"]`);
      nextButton?.focus();
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      const prevIndex = Math.max(currentIndex - 1, 0);
      const prevButton = accordionRef.current?.querySelector(`[data-index="${prevIndex}"]`);
      prevButton?.focus();
    }
  };

  return (
    <div className={`accordion ${className}`} ref={accordionRef}>
      {items.map((item, index) => {
        const isOpen = openItems.has(index);
        return (
          <div key={index} className="accordion-item">
            <button
              className="accordion-trigger"
              onClick={() => toggleItem(index)}
              onKeyDown={(e) => {
                handleKeyDown(e, index);
                handleArrowKey(e, index);
              }}
              aria-expanded={isOpen}
              aria-controls={`accordion-content-${index}`}
              data-index={index}
              type="button"
            >
              <span className="accordion-title">{item.question}</span>
              <span className={`accordion-icon ${isOpen ? 'open' : ''}`} aria-hidden="true">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M4 6L8 10L12 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </span>
            </button>
            <div
              id={`accordion-content-${index}`}
              className={`accordion-content ${isOpen ? 'open' : ''}`}
              aria-hidden={!isOpen}
            >
              <div className="accordion-content-inner">
                <p>{item.answer}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Accordion;
